module.exports = __webpack_public_path__ + "723e18f630f3c3e877e9a41e96f0e574.png";